import React from "react";
import {useKeycloak} from "@react-keycloak/web";
import {Route, Switch} from "react-router-dom";
import PrivateRoute from "../components/security/PrivateRoute";
import Loader from "../components/layout/Loader";
import { routes } from "../config/routes"
// import TemplatePrivate from "../components/layout/TemplatePrivate";
import TemplateBerryPublic from "../components/layout/TemplateBerryPublic";
import TemplateBerryPrivate from "../components/layout/TemplateBerryPrivate";
// import TemplatePublic from "../components/layout/TemplatePublic";


const AppRouter = () => {

    const { initialized} = useKeycloak();

    if (!initialized) {
        return <Loader open={true}/>
    }
    return <Switch>
        {
            routes.map((route, idx) => {
                const path = route.path + (route.param ? route.param : '');
                return <Route
                    exact
                    key={idx}
                    path={path}
                    render={props => route.private ?
                        <PrivateRoute roles={route.roles}>
                            <TemplateBerryPrivate>
                                <route.component {...props} />
                            </TemplateBerryPrivate>
                        </PrivateRoute>
                        :
                        <TemplateBerryPublic>
                            <route.component {...props} />
                        </TemplateBerryPublic>

                    }
                />
            })
        }
    </Switch>



}

export default AppRouter;
